/*****************************************************
Naam: useDashboardSettings.js
Locatie: src/components/Dashboard/hooks/useDashboardSettings.js
Datum: 2026-02-07
Versie: 1.0.0
******************************************************
Beschrijving:
Custom hook voor dashboard instellingen (kleuren, logo's).
******************************************************/

import { useState, useEffect, useCallback } from 'react';

const DEFAULT_SETTINGS = {
  backgroundColor: '#10b981',
  buttonColors: {
    klanten: '#10b981',
    vervoerders: '#10b981',
    statusAanvragen: '#3b82f6',
    emailAanvragen: '#10b981',
    palletTracking: '#10b981',
    importWhatsapp: '#10b981',
    lijsten: '#a855f7',
    aanvraagInkoop: '#10b981',
    prijsopgave: '#10b981',
    facturen: '#10b981'
  },
  buttonTextColors: {}
};

export const useDashboardSettings = () => {
  const [companyLogo, setCompanyLogo] = useState(null);
  const [backgroundLogo, setBackgroundLogo] = useState(null);
  const [dashboardSettings, setDashboardSettings] = useState(DEFAULT_SETTINGS);

  const loadLogosFromServer = useCallback(async () => {
    try {
      const response = await fetch('/api/get-logos');
      if (response.ok) {
        const result = await response.json();
        if (result.success && result.logos) {
          if (result.logos.company_logo) {
            setCompanyLogo(result.logos.company_logo);
            localStorage.setItem('companyLogo', result.logos.company_logo);
          }
          if (result.logos.background_logo) {
            setBackgroundLogo(result.logos.background_logo);
            localStorage.setItem('backgroundLogo', result.logos.background_logo);
          }
        }
      }
    } catch (error) {
    }
  }, []);

  const loadDashboardSettings = useCallback(async () => {
    try {
      const response = await fetch('/api/dashboard-settings');
      if (response.ok) {
        const result = await response.json();
        if (result.success && result.settings) {
          setDashboardSettings(prev => ({ ...prev, ...result.settings }));
        }
      }
    } catch (error) {
    }
  }, []);

  useEffect(() => {
    const logo = localStorage.getItem('companyLogo');
    const bgLogo = localStorage.getItem('backgroundLogo');
    
    if (logo) setCompanyLogo(logo);
    if (bgLogo) setBackgroundLogo(bgLogo);
    
    if (!logo || !bgLogo) {
      loadLogosFromServer();
    }
    
    loadDashboardSettings();
    
    const handleSettingsUpdate = (event) => {
      setDashboardSettings(event.detail);
    };
    
    window.addEventListener('dashboardSettingsUpdated', handleSettingsUpdate);
    
    return () => {
      window.removeEventListener('dashboardSettingsUpdated', handleSettingsUpdate);
    };
  }, [loadLogosFromServer, loadDashboardSettings]);

  const handleLogoUpdate = useCallback((newLogo) => {
    setCompanyLogo(newLogo);
  }, []);

  const handleBackgroundUpdate = useCallback((newBgLogo) => {
    setBackgroundLogo(newBgLogo);
  }, []);

  return {
    companyLogo,
    backgroundLogo,
    dashboardSettings,
    handleLogoUpdate,
    handleBackgroundUpdate
  };
};

export default useDashboardSettings;
